var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSReadDone16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.291 3.255a.75.75 0 0 1-.022 1.06L5.015 10.31a.76.76 0 0 1-1.052 0L1.231 7.69A.75.75 0 0 1 2.27 6.608l2.22 2.127 5.742-5.502a.75.75 0 0 1 1.06.022Zm4.261-.024a.75.75 0 0 1-.022 1.06l-6.261 6A.75.75 0 0 1 8.23 9.208l6.261-6a.75.75 0 0 1 1.06.023Z"
})));
export default SvgIcSReadDone16;